import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useSnackbar } from 'notistack';
import React from 'react';

import { useCustomStore } from '../../../hooks';
import { AccessTypes } from '../../../types';
import MembershipDriversGrid from './components/MembershipDriversGrid';
import MembershipIncidentsGrid from './components/MembershipIncidentsGrid';
import MembershipRoadUnitsGrid from './components/MembershipRoadUnitsGrid';
import ServicesList from './components/ServicesList';
import ViewMembershipDetailsModal from './components/ViewMembershipDetailsModal';

const MotorClubMembership = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { authStore, motorClubMembershipStore } = useCustomStore();
  const [isDetailsModalOpen, setIsDetailsModalOpen] = React.useState(false);
  const [hasActiveDriverMembership, setHasActiveDriverMembership] =
    React.useState(false);
  const [openAddIncidentRequestKey, setOpenAddIncidentRequestKey] =
    React.useState(0);
  const showDriverView =
    authStore.UserAccessType === AccessTypes.Driver ||
    authStore.UserAccessType === AccessTypes.OwnerOperator;

  React.useEffect(() => {
    let isMounted = true;
    if (showDriverView) {
      setHasActiveDriverMembership(true);
    } else {
      motorClubMembershipStore.rootStore.apiStore.motorClubMembershipApiStore
        .hasActiveDriverMembership()
        .then((responseOrErr) => {
          if (!isMounted) {
            return;
          }

          if (responseOrErr.isErr()) {
            enqueueSnackbar(responseOrErr.error.message, {
              variant: 'error',
            });
            return;
          }

          setHasActiveDriverMembership(
            responseOrErr.value.hasActiveDriverMembership,
          );
        });
    }

    return () => {
      isMounted = false;
    };
  }, [enqueueSnackbar, motorClubMembershipStore, showDriverView]);

  return (
    <Box
      sx={{
        padding: {
          md: '24px 24px 0 24px',
          xs: '16px 16px 0 16px',
        },
      }}>
      <Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '10px',
          }}>
          <Link
            component="button"
            onClick={() => setIsDetailsModalOpen(true)}
            sx={{
              '&:hover': {
                opacity: 0.85,
                textDecoration: 'none',
              },
              alignItems: 'center',
              color: '#7D1935',
              display: 'inline-flex',
              fontFamily: 'FiraSans-SemiBold',
              fontSize: '15.5px',
              gap: '6px',
              textDecoration: 'none',
            }}
            underline="none">
            <BadgeOutlinedIcon sx={{ fontSize: 15 }} />
            View Subscription Details
          </Link>
        </Box>

        <ServicesList
          hasActiveDriverMembership={hasActiveDriverMembership}
          onSubmitTrafficIncident={() => {
            setOpenAddIncidentRequestKey((prev) => prev + 1);
          }}
        />
      </Box>

      <ViewMembershipDetailsModal
        onClose={() => setIsDetailsModalOpen(false)}
        open={isDetailsModalOpen}
        showDriverView={showDriverView}
      />

      <Box sx={{ marginBottom: '20px', marginTop: '24px' }}>
        <MembershipIncidentsGrid
          openAddIncidentRequestKey={openAddIncidentRequestKey}
          showDriverView={showDriverView}
        />
      </Box>

      {!showDriverView ? (
        <Box sx={{ marginBottom: '20px' }}>
          <MembershipDriversGrid />
        </Box>
      ) : null}

      <Box sx={{ paddingBottom: '20px' }}>
        <MembershipRoadUnitsGrid showDriverView={showDriverView} />
      </Box>
    </Box>
  );
};

export default MotorClubMembership;
